import Rails from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";
import "bootstrap";
import "tooltipster";
import "jquery.autocomplete";
import "magnific-popup";
import "node-waves";

import OktaTokenManager from "../services/oktaTokenManager";

window.Rails = Rails;
Rails.start();

ActiveStorage.start();
window.OktaTokenManager = OktaTokenManager;
OktaTokenManager.init();

// JS imports of needed
import "../legacy/main";

// CSS
import "bootstrap/scss/bootstrap";
import "@fortawesome/fontawesome-free/css/all";
// import "@fortawesome/fontawesome-free/scss/fontawesome";
// import "@fortawesome/fontawesome-free/scss/solid";
// import "@fortawesome/fontawesome-free/scss/regular";
import "./application.scss";

// Images
const images = require.context("../../assets/images", true);
const imagePath = (name) => images(name, true);

// Import icon for Okta widget
import iconUrl from '../../assets/images/icon.svg';
window.oktaIconUrl = iconUrl;

document.documentElement.style.setProperty('--okta-icon-url', `url(${window.oktaIconUrl})`);

function initOktaWidget() {
  if (typeof window.oktaSignIn !== 'undefined') {
    window.oktaSignIn.on('pageRendered', function() {
      // Create wrapper for icon and title
      const headerWrapper = document.createElement('div');
      headerWrapper.className = 'okta-header-wrapper';

      // Create icon div
      const iconDiv = document.createElement('div');
      iconDiv.className = 'okta-icon';
      headerWrapper.appendChild(iconDiv);

      // Create and style title
      const loginTitle = document.createElement('h2');
      loginTitle.textContent = 'Login';
      loginTitle.className = 'okta-login-title';
      headerWrapper.appendChild(loginTitle);

      // Add wrapper before the widget content
      const authContent = document.querySelector('#okta-sign-in .primary-auth');
      if (authContent) {
        authContent.parentNode.insertBefore(headerWrapper, authContent);

        // Set placeholders
        const emailInput = document.querySelector('#user_email');
        const passwordInput = document.querySelector('#user_password');
        if (emailInput) emailInput.placeholder = 'Email';
        if (passwordInput) passwordInput.placeholder = 'Password';
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const oktaContainer = document.querySelector('#okta-login-container');
  
  if (oktaContainer) {
    initOktaWidget();
    
    if (typeof window.oktaSignIn === 'undefined') {
      const checkInterval = setInterval(function() {
        if (typeof window.oktaSignIn !== 'undefined') {
          initOktaWidget();
          clearInterval(checkInterval);
        }
      }, 100);

      setTimeout(() => clearInterval(checkInterval), 10000);
    }
  }
});
